import { render, staticRenderFns } from "./WorkflowDocumentPreview.vue?vue&type=template&id=0a6a0ca4&scoped=true"
import script from "./WorkflowDocumentPreview.vue?vue&type=script&lang=js"
export * from "./WorkflowDocumentPreview.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDocumentPreview.vue?vue&type=style&index=0&id=0a6a0ca4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a0ca4",
  null
  
)

export default component.exports